import { render, staticRenderFns } from "./GoodsEvaluation.vue?vue&type=template&id=2bfd97b4&scoped=true"
import script from "./GoodsEvaluation.vue?vue&type=script&lang=js"
export * from "./GoodsEvaluation.vue?vue&type=script&lang=js"
import style0 from "./GoodsEvaluation.vue?vue&type=style&index=0&id=2bfd97b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfd97b4",
  null
  
)

export default component.exports